import { PrizeStatus, PrizeType } from '@/types/shared';
/**
 * 允许展示的券状态
 */
const ALLOWED_PRIZE_STATUSES = [PrizeStatus.CAN_DRAW,
    // 1 可领取
    PrizeStatus.NOT_USED,
    // 3 未使用
    PrizeStatus.DRAWN // 7 已领取
];
/**
 * 一天的毫秒数
 */
const ONE_DAY_MS = 24 * 60 * 60 * 1000;
/**
 * 根据券状态获取按钮文案
 */
function getButtonText(prizeStatus, rewardType, jumpUrl) {
    switch (prizeStatus) {
        case PrizeStatus.CAN_DRAW:
            return '领取';
        case PrizeStatus.NOT_USED:
        case PrizeStatus.DRAWN:
            let isValidGoto = !!jumpUrl;
            if (!jumpUrl) {
                isValidGoto = [PrizeType.NEXT_COUPON, PrizeType.GOD_COUPON, PrizeType.TOP_COUPON, PrizeType.POINTS].includes(rewardType);
            }
            return isValidGoto ? '去使用' : '已领取';
        default:
            return '';
    }
}
function getButtonValid(prizeStatus, rewardType, jumpUrl) {
    if (prizeStatus === PrizeStatus.CAN_DRAW) {
        return true;
    }
    if (prizeStatus === PrizeStatus.NOT_USED || prizeStatus === PrizeStatus.DRAWN) {
        let isValidGoto = !!jumpUrl;
        if (!jumpUrl) {
            isValidGoto = [PrizeType.NEXT_COUPON, PrizeType.GOD_COUPON, PrizeType.TOP_COUPON, PrizeType.POINTS].includes(rewardType);
        }
        return isValidGoto;
    }
    return false;
}
/**
 * 判断过期时间是否超过1天
 */
function checkExpireIsOverDay(expireTime) {
    if (!expireTime) {
        return false;
    }
    const now = Date.now();
    const diff = expireTime - now;
    return diff > ONE_DAY_MS;
}
/**
 * 处理券列表数据
 * 1. 筛选状态为 1、3、7 的券
 * 2. 添加 expireIsOverDay 字段
 * 3. 添加 buttonText 字段
 */
export function processPrizeList(prizeList) {
    return prizeList.filter(prize => ALLOWED_PRIZE_STATUSES.includes(prize.prizeStatus)).map(prize => ({
        ...prize,
        expireIsOverDay: checkExpireIsOverDay(prize.expireTime),
        buttonText: getButtonText(prize.prizeStatus, prize.rewardType, prize.jumpUrl),
        isButtonValid: getButtonValid(prize.prizeStatus, prize.rewardType, prize.jumpUrl)
    }));
}
